import { useDispatch } from "react-redux";
import { bindActionCreators, createAction } from "@reduxjs/toolkit";

import { ActionType } from "./types/actionType";
import {
  GetNonInventoryPayload,
  DeleteNonInventoryPayload,
  UpdateNonInventoryPayload,
  GetManyNonInventoryPayload,
  CreateNonInventoryPayload,
} from "./types/types";

export const createNonInventory = createAction<CreateNonInventoryPayload>(
  ActionType.CREATE_NON_INVENTORY
);

export const updateNonInventory = createAction<UpdateNonInventoryPayload>(
  ActionType.UPDATE_NON_INVENTORY
);

export const deleteNonInventory = createAction<DeleteNonInventoryPayload>(
  ActionType.DELETE_NON_INVENTORY
);

export const retrieveNonInventory = createAction<GetNonInventoryPayload>(
  ActionType.RETRIEVE_NON_INVENTORY
);

export const retrieveManyNonInventory = createAction<GetManyNonInventoryPayload>(
  ActionType.RETRIEVE_MANY_NON_INVENTORY
);

export const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(
    {
      createNonInventory,
      updateNonInventory,
      deleteNonInventory,
      retrieveNonInventory,
      retrieveManyNonInventory,
    },
    dispatch
  );
};

export const sagaActions = {
  createNonInventory,
  updateNonInventory,
  deleteNonInventory,
  retrieveNonInventory,
  retrieveManyNonInventory,
};
